export default __webpack_public_path__ + "315defbb7d61672699e89090861e7417.svg";